import { render, staticRenderFns } from "./ModuleViewer.vue?vue&type=template&id=3778df5f&"
import script from "./ModuleViewer.vue?vue&type=script&lang=js&"
export * from "./ModuleViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModuleViewer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports